import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next';
import Unity, { UnityContext } from "react-unity-webgl";
import GuestBookComment from './OfficeComponents/GuestBookComment';

import Modal from 'react-bootstrap/Modal'

class Office extends Component {

    progressQuotes = [
        "Hang in there, we're loading an awesome experience for you!",
        "A journey of a thousand miles begins with a single step. ~Lao Tzu",
        "Little by little, a little becomes a lot. ~Tanzanian Proverb",
        "Progress is the attraction that moves humanity. ~Marcus Garvey"
    ]
    state = {
        unityContext: {},
        loading: true,
        progression: 0,
        progressIndex: 0,
        progressStuck: false,
        lastProgression: 0
    }
    constructor(props) {
        super(props)

        this.setProgression = this.setProgression.bind(this)
        this.progressTimer = this.progressTimer.bind(this)
    }

    componentDidMount() {

        const { t } = this.props;
        document.title = t("titleappname") + t("title_office")

        let mobile = (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent))

        // if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
        //     // Mobile device style: fill the whole browser client area with the game canvas:

        //     mobile = true
        //     // var meta = document.createElement('meta');
        //     // meta.name = 'viewport';
        //     // meta.content = 'width=device-width, height=device-height, initial-scale=1.0, user-scalable=no, shrink-to-fit=yes';
        //     // document.getElementsByTagName('head')[0].appendChild(meta);
        //     // container.className = "unity-mobile";

        //     // // To lower canvas resolution on mobile devices to gain some
        //     // // performance, uncomment the following line:
        //     // // config.devicePixelRatio = 1;

        //     // canvas.style.display = "none"

        //     // var mobile = document.querySelector("#mobile")
        //     // mobile.style.width = window.innerWidth + 'px'
        //     // mobile.style.height = window.innerHeight + 'px'
        //     // mobile.style.display = "flex"
        //   } else {
        //     mobile = false
        //   }

        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        const officeId = urlParams.get('id')

        let buildUrl
        if (window.location.origin.includes("localhost")) {
            window.officeConfig = {
                officeId,
                websiteUrl: "https://localhost",
                apiUrl: "https://localhost:3080"
            }
            buildUrl = "https://localhost:3080/office_build"; //Local - put the files in /server/public/office/build
        } else if (window.location.origin.includes("dev.")) {
            //buildUrl = "https://simplymetaverse.s3.amazonaws.com/v06"; //S3 
            buildUrl = "https://d13ebz8fhj4h1z.cloudfront.net/v06"; //CDN 
            window.officeConfig = {
                officeId,
                websiteUrl: "https://dev.simplyflows.com",
                apiUrl: "https://dev.api.simplyflows.com",
            }
        } else {
            //buildUrl = "https://simplymetaverse.s3.amazonaws.com/v06"; //S3 
            buildUrl = "https://d13ebz8fhj4h1z.cloudfront.net/v06"; //CDN 
            window.officeConfig = {
                officeId,
                websiteUrl: "https://simplyflows.com",
                apiUrl: "https://api.simplyflows.com",
            }
        }

        const unityContext = new UnityContext({
            loaderUrl: buildUrl + "/Web.loader.js",
            dataUrl: buildUrl + "/Web.data.gz",
            frameworkUrl: buildUrl + "/Web.framework.js.gz",
            codeUrl: buildUrl + "/Web.wasm.gz",
        });
        const style = { width: (window.innerWidth) + 'px', height: (window.innerHeight) + 'px' };
        unityContext.on("progress", (progression) => this.setProgression(progression));
        unityContext.on("loaded", () => {
            var canvas = document.getElementById("unity-canvas-1");
            canvas.setAttribute("tabindex", "1");
            canvas.focus();
        })
        unityContext.on("OpenGuestBookComment", () => {
            this.setState({ displayGuestBookComment: true });
        });
        this.setState({ loading: false, unityContext, style, mobile })

        setTimeout(this.progressTimer, 5000)
    }

    setProgression(progression) {
        progression *= 100
        progression = Math.round(progression)
        this.setState({ progression })
    }

    progressTimer() {
        if (this.state.progression < 80) {
            if (this.state.progression == this.state.lastProgression) {
                alert(this.state.progression + " " +  this.state.lastProgression)
                debugger
                this.setState({ progressStuck: true })
                return
            }
            var newIndex = this.state.progressIndex + 1
            if (newIndex >= this.progressQuotes.length)
                newIndex = 0
            this.setState({ progressIndex: newIndex, lastProgression : this.state.progression })
            setTimeout(this.progressTimer, 5000)
        }
    }


    onGuestBookCommentChange(commentState) {
        var s = ""
        if (commentState.email) {
            s += commentState.email
        }
        if (commentState.name) {
            s += " - " + commentState.name
        }

        if (commentState.notes) {
            s += "\n" + commentState.notes
        }
        this.state.unityContext.send("GuestsBook (1)", "SetComment", s);
    }

    render() {
        // return this.state.mobile ? <div id="mobile"
        //     style="display: none;justify-content: center; align-items: center; font-family: 'Poppins',sans-serif;">
        //     <p style="font-size: large; margin: 50px; text-align: center;">
        //     The metaverse is only supported in desktop browsers currently.<br /><br />Mobile apps are coming soon.<br /><br />Questions or suggestions? <a href="https://simplyflows.com/contact/" style="color: #d01a62;">Let's&nbsp;connect!</a>
        //     </p>
        // </div>
        // : 
        return <>

            {this.state.loading ? "" :
                <Unity unityContext={this.state.unityContext} style={{ width: (this.props.windowWidth) + 'px', height: (window.innerHeight) + 'px' }} devicePixelRatio={2} />}
            {this.state.progression < 100 ?
                <div style={{ position: 'absolute', height: "100%", width: "100%" }}>
                    <div style={{ fontSize: "large", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <div>
                            {this.state.mobile ? <span>The metaverse is only supported in desktop browsers currently.<br /><br />Mobile apps are coming soon.<br /><br />Questions or suggestions? <a href="https://simplyflows.com/contact/">Let's&nbsp;connect!</a></span>
                                : this.state.progressStuck
                                    ? <span>Looks like downloading is very slow. You may want to <a href="javascript:window.location=window.location">refresh</a>. If the issue persists, please <a href="https://simplyflows.com/contact/">let us know</a>.<br /><br />
                                        {this.state.progression} %</span>
                                    : <>{this.state.progression > 80 ? "Welcome to your virtual workspace!" : this.progressQuotes[this.state.progressIndex]} <br />
                                        <br />
                                        <span class="progress">
                                            <div class="progress-bar" role="progressbar" style={{ width: this.state.progression + "%", background: "#d01a62" }} aria-valuenow={this.state.progression} aria-valuemin="0" aria-valuemax="100"></div>
                                        </span>
                                    </>
                            }

                        </div>


                    </div>

                </div> : ""
            }
            <Modal show={this.state.displayGuestBookComment} onHide={() => this.setState({ displayGuestBookComment: false })}>
                <Modal.Header closeButton>
                    <Modal.Title>Guest Book</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <GuestBookComment onChange={(s) => this.onGuestBookCommentChange(s)} onCompleted={(s) => this.setState({ displayGuestBookComment: false })}/>
                </Modal.Body>
            </Modal>
        </>
    }
}
export default withRouter(withTranslation()(Office), Office);